import { render, staticRenderFns } from "./CustomerIntroPage.vue?vue&type=template&id=7ccc451b&"
import script from "./CustomerIntroPage.vue?vue&type=script&lang=js&"
export * from "./CustomerIntroPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports